(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["metaobject-archive"] && !Shopify.designMode) return;
  try {
    
(function(){
  try{
    const root = document.currentScript.closest('.mo-archive');
    if(!root) return;
    const container = root.querySelector('.mo-container');
    const toggles = root.querySelectorAll('.mo-toggle');
    toggles.forEach(btn=>{
      btn.addEventListener('click', function(e){
        e.preventDefault();
        const to = this.getAttribute('data-layout');
        container.classList.remove('mo-grid','mo-list');
        container.classList.add('mo-' + to);
        // tweak button opacity UI
        toggles.forEach(t=> t.style.opacity = t.getAttribute('data-layout') === to ? '1' : '.6');
      });
    });
  }catch(e){}
})();

  } catch(e) { console.error(e); }
})();
})();
